export default __webpack_public_path__ + "static/2-4-3-0-76672db8b0cd140d1e8486b44988b328.jpg";